const o = {
  modal: 9997,
  modalBackdrop: 9998,
  modalContent: 9999,
  drawer: 8997,
  drawerBackdrop: 8998,
  drawerContent: 8999,
  dropdown: 10,
  phoneDropdown: 2
};
export {
  o as Z_INDEX
};
//# sourceMappingURL=zIndex.es.js.map
